import { IPredefinedTheme } from "../../Themes";
import img1 from "./screenshot.png";

export const Theme: IPredefinedTheme = {
  name: "Purple",
  credit: "zer0ney",
  description: "Essentially all defaults except for purple replacing the main colors",
  reference: "https://discord.com/channels/415207508303544321/921991895230611466/922091815849570395",
  screenshot: img1,
  colors: {
    primarylight: "#BA55D3",
    primary: "#9370DB",
    primarydark: "#8A2BE2",
    successlight: "#BA55D3",
    success: "#9370DB",
    successdark: "#8A2BE2",
    errorlight: "#f00",
    error: "#c00",
    errordark: "#900",
    secondarylight: "#AAA",
    secondary: "#888",
    secondarydark: "#666",
    warninglight: "#ff0",
    warning: "#cc0",
    warningdark: "#990",
    infolight: "#69f",
    info: "#36c",
    infodark: "#039",
    welllight: "#444",
    well: "#222",
    white: "#fff",
    black: "#000",
    hp: "#dd3434",
    money: "#ffd700",
    hack: "#adff2f",
    combat: "#faffdf",
    cha: "#a671d1",
    int: "#6495ed",
    rep: "#faffdf",
    disabled: "#66cfbc",
    backgroundprimary: "#000",
    backgroundsecondary: "#000",
    button: "#333",
  },
};
